module.exports = __webpack_public_path__ + "static/img/sign-add-icon.67980c32.png";